import {
  Bar,
  BarChart,
  Cell,
  ReferenceLine,
  ResponsiveContainer,
  XAxis,
} from 'recharts';
import { indigoColors } from '~/common/theme/indigo.colors';
import { formatPercent } from '~/common/utils/formatter';
import { getValueFormatter } from './chart.utils';
import { CHART_COLORS } from './constants';
import { MetricChartProps } from './types';

export const MetricBarChart = ({
  data,
  showLegend = false,
  valueUnit,
  labelUnit,
}: MetricChartProps) => {
  return (
    <ResponsiveContainer height="100%" width="100%">
      <BarChart
        data={data}
        margin={{
          bottom: showLegend ? 16 : 0,
          top: 16,
          left: showLegend ? 25 : 0,
        }}
      >
        {showLegend && (
          <ReferenceLine
            isFront
            label={{
              position: 'left',
              fill: indigoColors.whiteAlpha[500],
              value: formatPercent(0),
            }}
            stroke={indigoColors.whiteAlpha[500]}
            y={0}
          />
        )}
        <Bar
          dataKey="value"
          fill={indigoColors.purple[500]}
          label={{
            position: 'top',
            formatter: getValueFormatter({ unit: valueUnit }),
            fontSize: 14,
          }}
          maxBarSize={20}
        >
          {showLegend &&
            data?.map((entry, index) => {
              return <Cell key={`cell-${index}`} fill={CHART_COLORS[index]} />;
            })}
        </Bar>
        {!showLegend && (
          <XAxis
            dataKey="label"
            tick={{ fontSize: 14 }}
            tickFormatter={getValueFormatter({ unit: labelUnit })}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};
